<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'registration'"
    class="page"
  >
    <div class="mt2 mb4 fs5 fw4 fc--primary">
      {{ clinicInfo.fullname }}
    </div>
    <div class="mb4 fc--primary">
      COVID-19防疫實名制措施
    </div>
    <div
      class="page__text bc--secondary border-radius-3 p3 mb6 mh2 align--left"
    >
      若您不同意提供可實際聯絡到的個人資料(連絡電話)，將無法進入本醫院訪客及探嬰。
      <br>
      <br>
      1. 為防堵疫情而有必要時蒐集其資料，提供衛生主管機關依傳染病防治法等規定進行疫情調查及聯繫使用。
      <br>
      2.本院探嬰、訪客採線上預約制。請於前一天08:00-20:00申請預約，未預約者當日無法探嬰或訪客。
      <br>
      3.當日探嬰或訪客，請出示健保卡。
      <br>
      4.本院探嬰、訪客時段為周一至周六11:00--11:45，每床寶寶限15分鐘。
      <br>
      <br>
      同一病患限一位訪客(不得輪替)，若額滿則不受理預約。
    </div>
    <div class="page__form mb7">
      <input
        type="text"
        placeholder="住院親友姓名"
        v-model="memberInfo.visitedName"
      >
      <input
        type="text"
        placeholder="住院親友床號"
        v-model="memberInfo.bedNumber"
      >
      <input
        type="text"
        v-model="memberInfo.name"
        placeholder="真實姓名"
      >
      <input
        type="text"
        placeholder="身份證號碼"
        v-model="memberInfo.twid"
      >
      <input
        type="text"
        v-model="memberInfo.mobile"
        placeholder="手機號碼"
      >
    </div>
    <div class="page__form mb6">
      <div
        v-for="filed in registrationForm"
        :key="filed"
        class="mb5"
      >
        <div class="mh3 mb2 align--left">
          {{ filed.question }}
        </div>
        <select v-model="filed.response">
          <option value="">
            請選擇
          </option>
          <option
            v-for="option in filed.options"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </div>
    <div
      @click="send"
      class="label label--primary mb5"
    >
      送出
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @done="liff.closeWindow"
  />
</template>

<script>
import { reactive, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import modelRegistrationForm from './registrationForm';

export default {
  setup() {
    const route = useRoute();
    const page = ref('initialization');
    const clinicInfo = ref(null);
    const memberInfo = reactive({
      visitedName: '',
      bedNumber: '',
      name: '',
      twid: '',
      mobile: '',
    });
    const registrationForm = reactive(
      spiderman.generate.deepCopy(modelRegistrationForm),
    );

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        const { clinic } = route.params;
        if (clinic === 'heart') {
          await composable.member.initialize({
            liffId: '1656042583-6LlGRnmA',
            clinic: '金安心',
          });
        } else if (clinic === 'beauty') {
          await composable.member.initialize({
            liffId: '',
            clinic: '金禾美',
          });
        }
        clinicInfo.value = spiderman.clinic[composable.member.info.clinic];

        if (composable.member.info.verified) {
          const { name, twid, mobile } = composable.member.info;
          memberInfo.name = name;
          memberInfo.twid = twid;
          memberInfo.mobile = mobile;
        }

        page.value = 'registration';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    async function send() {
      try {
        spiderman.form.verify(memberInfo);
        verifyRegistration(registrationForm);
        const postForm = generatePostForm(registrationForm);

        composable.loading.show('傳送中，請稍候');

        const response = await api.visitorRegistrations.send(
          composable.member, memberInfo, postForm,
        );

        composable.modal.done(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function verifyRegistration(form) {
      form.forEach((filed) => {
        if (filed.response.trim() === '') throw Error(`請回答 ${filed.question}`);
      });
    }

    function generatePostForm(form) {
      const postForm = form.map((filed) => {
        const { question, response } = filed;
        return {
          question, response,
        };
      });

      return postForm;
    }

    return {
      liff: spiderman.liff,
      page,
      clinicInfo,
      composable,
      memberInfo,
      registrationForm,
      send,
    };
  },
};
</script>
